
/* ============================== src/components/discussion/MentionPopup.jsx ============================== */
// src/components/discussion/MentionPopup.jsx
import { useCallback } from "react";
import { createPortal } from "react-dom";
import { initials } from "../../utils/date";
import { Clickable } from "../Clickable";

/**
 * Попап автодополнения @-упоминаний.
 *
 * Координаты (x, y) приходят снаружи из useMentions - там они
 * вычисляются по getBoundingClientRect textarea в момент появления
 * попапа. Передаются в CSS через переменные --popup-x / --popup-y.
 *
 * Позиционирование - через callback-ref, а не через useRef +
 * useLayoutEffect. Причина: useLayoutEffect запускается по смене
 * deps и НЕ запускается, когда DOM-узел перемонтируется, а deps
 * остались те же. В нашем сценарии это реальный баг: попап
 * размонтируется при candidates.length === 0 (например, пользователь
 * стёр @Гендир до @), popup.visible при этом остаётся true, x/y не
 * меняются - при возврате div у него НЕ устанавливаются переменные,
 * и попап уходит в угол (var(--popup-x, 0)).
 *
 * Callback-ref React вызывает на каждом монтировании узла - на
 * возврате попапа после null координаты встают корректно.
 * useCallback с deps [popup.x, popup.y] покрывает второй случай:
 * если координаты меняются, пока попап открыт (ресайз окна, скролл
 * страницы под курсором), React снимает старый callback-ref (с null)
 * и вызывает новый - переменные переустанавливаются.
 *
 * Хуки вызываются до раннего return - правило Hooks требует
 * безусловного вызова. При popup.visible === false / пустых
 * candidates компонент возвращает null, callback-ref не вызывается
 * (React не создаёт DOM-узел), координаты никуда не пишутся.
 */
export default function MentionPopup({ popup, candidates, onPick }) {
  const setRef = useCallback(
    (el) => {
      if (!el) return;
      el.style.setProperty("--popup-x", `${popup.x}px`);
      el.style.setProperty("--popup-y", `${popup.y}px`);
    },
    [popup.x, popup.y],
  );

  if (!popup.visible || candidates.length === 0) return null;

  return createPortal(
    <div ref={setRef} className="mention-pop">
      {candidates.map((e) => (
        <Clickable
          key={e.id}
          className="mention-item clickable-reset"
          onClick={() => onPick(e)}
        >
          <span className="avatar xs">{initials(e.first, e.last)}</span>
          {e.last} {e.first}
        </Clickable>
      ))}
    </div>,
    document.body,
  );
}
